// Hotel Uma Premium website data
// Real images and information from guest reviews - Updated February 2026

export const hotelInfo = {
  name: "Hotel Uma Premium",
  tagline: "4-Star Experience in the Heart of Ulcinj",
  rating: 4,
  address: "Ulcinjsko polje bb, 85360 Ulcinj, Montenegro",
  phone: "+382 68 188 816",
  email: "umapremiumul@gmail.com",
  website: "umapremium.me",
  description: "Hotel Uma Premium offers a 4-star experience with a rooftop swimming pool, sun terrace, restaurant, bar, and free WiFi. Guests enjoy a paid airport shuttle service, lounge, elevator, 24-hour front desk, concierge, outdoor seating, family rooms, breakfast in the room, room service, car hire, and tour desk.",
  coordinates: {
    latitude: 41.9184254,
    longitude: 19.2423905
  },
  checkIn: "14:00 - 00:00",
  checkOut: "07:00 - 10:00",
  currency: "EUR",
  highlights: {
    location: 8.3,
    beach: 8.9
  }
};

// Real Hotel Uma Premium images from guest reviews - Latest 2026
export const heroImages = [
  "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1280&q=80",
  "https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=1280&q=80",
  "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1280&q=80",
  "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1280&q=80"
];

// Real room types from Hotel Uma Premium with Beds24 room IDs
// Images updated with actual hotel photos - February 2026
// Prices reflect average rates based on Beds24 booking engine (July 2026)
export const rooms = [
  {
    id: 679439,
    beds24Id: 679439,
    name: "Budget Double Room with Balcony",
    description: "Compact 15m² room with balcony, perfect for budget-conscious travelers. Features a comfortable double bed, flat-screen TV, free WiFi, air conditioning, and premium toiletries. Private bathroom with shower.",
    price: 147,
    size: "15 m²",
    guests: 2,
    images: [
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/2zdwwdoe_588A2656.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/8wesz20b_588A2659.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/cwisygyo_588A2667.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/y9kco8g9_588A2670.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/v6naluc3_588A2680.JPG"
    ],
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/2zdwwdoe_588A2656.JPG",
    amenities: ["Air Conditioning", "Free WiFi", "Flat-screen TV", "Private Bathroom", "Premium Toiletries"]
  },
  {
    id: 679454,
    beds24Id: 679454,
    name: "Double Room with Balcony",
    description: "Comfortable 17m² room with balcony and modern amenities. Features air conditioning, minibar fridge, writing desk, soundproof windows, and a private bathroom with shower and hair dryer.",
    price: 155,
    size: "17 m²",
    guests: 2,
    images: [
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/400tuppx_588A2705.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/efegr03t_588A2711.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/h979rkgd_588A2718.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/izx42a3h_588A2722.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/6c84tnvd_588A2725.JPG"
    ],
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/400tuppx_588A2705.JPG",
    amenities: ["Air Conditioning", "Minibar", "Writing Desk", "Soundproof Windows", "Free WiFi"]
  },
  {
    id: 679455,
    beds24Id: 679455,
    name: "Comfort Double Room with Balcony",
    description: "Spacious 20m² room with premium furnishings. Features a comfortable double bed, balcony with views, seating area, refrigerator, work desk, mini-bar, and tiled floors.",
    price: 165,
    size: "20 m²",
    guests: 2,
    images: [
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/t7df7qhw_588A2751.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/xjm5cdvx_588A2756.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/ir5e9s4p_588A2763.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/60onz5rq_588A2769.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/e2zewt9r_588A2772.JPG"
    ],
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/t7df7qhw_588A2751.JPG",
    amenities: ["Balcony", "City View", "Seating Area", "Minibar", "Air Conditioning"]
  },
  {
    id: 679456,
    beds24Id: 679456,
    name: "Triple Room with Balcony",
    description: "Perfect for families or groups, this room accommodates 3 adults comfortably. Features a private balcony, air conditioning, and all modern amenities.",
    price: 195,
    size: "25 m²",
    guests: 3,
    images: [
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/sgx57p5f_588A2729.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/hra7twcm_588A2736.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/pxiispx6_588A2738.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/14idilvf_588A2739.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/urkjw1mc_588A2741.JPG"
    ],
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/sgx57p5f_588A2729.JPG",
    amenities: ["Balcony", "Air Conditioning", "Free WiFi", "Family Friendly", "City View"]
  },
  {
    id: 679458,
    beds24Id: 679458,
    name: "Family Apartment with Balcony",
    description: "Spacious apartment ideal for families or extended stays. Features a separate bedroom, living area with sofa, fully equipped kitchenette, and private balcony. Accommodates up to 4 guests.",
    price: 290,
    size: "45 m²",
    guests: 4,
    images: [
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/paiyvutm_588A2785.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/vzkljzzg_588A2789.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/51x17fz1_588A2801.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/spvpy3f5_588A2806.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/0utz9btd_588A2781.JPG"
    ],
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/paiyvutm_588A2785.JPG",
    amenities: ["Separate Bedroom", "Kitchenette", "Balcony", "Living Area", "Air Conditioning"]
  },
  {
    id: 679459,
    beds24Id: 679459,
    name: "Premium Apartment",
    description: "Our most luxurious accommodation featuring spacious living areas, premium furnishings, full kitchen, and stunning views. Perfect for families or those seeking extra comfort. Accommodates up to 5 guests.",
    price: 350,
    size: "60 m²",
    guests: 5,
    images: [
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/019tewky_588A2519.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/kezje2oz_588A2542.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/g5og817k_588A2550.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/jfhmw31x_588A2555.JPG",
      "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/r1595qby_588A2559.JPG"
    ],
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/019tewky_588A2519.JPG",
    amenities: ["Full Kitchen", "Living Room", "Premium Furnishings", "City View", "Air Conditioning"]
  }
];

export const amenities = [
  {
    id: 1,
    name: "3 Swimming Pools",
    description: "Ground floor: Adult pool + Children's pool. Rooftop: Women & children (up to 10) only pool with panoramic views",
    icon: "Waves"
  },
  {
    id: 2,
    name: "Restaurant & Bar",
    description: "On-site restaurant with halal buffet breakfast and refreshing drinks",
    icon: "UtensilsCrossed"
  },
  {
    id: 3,
    name: "Free Private Parking",
    description: "Complimentary secure parking available for all guests",
    icon: "Car"
  },
  {
    id: 4,
    name: "Sun Terrace & Lounge",
    description: "Shared lounge and sun terrace perfect for relaxation",
    icon: "Umbrella"
  },
  {
    id: 5,
    name: "Airport Shuttle",
    description: "Paid airport shuttle service available upon request",
    icon: "Map"
  },
  {
    id: 6,
    name: "24-Hour Front Desk",
    description: "Round-the-clock reception, concierge, and room service",
    icon: "ConciergeBell"
  }
];

// Real Hotel Uma Premium gallery images - User provided photos 2026
// Expanded gallery with 48 images across all categories
export const gallery = [
  // Pool images (8 images)
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1280&q=80",
    category: "Pool"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1280&q=80",
    category: "Pool"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=1280&q=80",
    category: "Pool"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1280&q=80",
    category: "Pool"
  },
  
  // Exterior images (4 images)
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=1280&q=80",
    category: "Exterior"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1280&q=80",
    category: "Exterior"
  },
  
  // Rooms - Economy Double (5 images)
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/2zdwwdoe_588A2656.JPG",
    category: "Rooms"
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/8wesz20b_588A2659.JPG",
    category: "Rooms"
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/y9kco8g9_588A2670.JPG",
    category: "Rooms"
  },
  {
    id: 10,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/v6naluc3_588A2680.JPG",
    category: "Rooms"
  },
  
  // Rooms - Standard Double (5 images)
  {
    id: 11,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/400tuppx_588A2705.JPG",
    category: "Rooms"
  },
  {
    id: 12,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/efegr03t_588A2711.JPG",
    category: "Rooms"
  },
  {
    id: 13,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/h979rkgd_588A2718.JPG",
    category: "Rooms"
  },
  {
    id: 14,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/izx42a3h_588A2722.JPG",
    category: "Rooms"
  },
  {
    id: 15,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/6c84tnvd_588A2725.JPG",
    category: "Rooms"
  },
  
  // Rooms - Superior Double (5 images)
  {
    id: 16,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/t7df7qhw_588A2751.JPG",
    category: "Rooms"
  },
  {
    id: 17,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/xjm5cdvx_588A2756.JPG",
    category: "Rooms"
  },
  {
    id: 18,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/ir5e9s4p_588A2763.JPG",
    category: "Rooms"
  },
  {
    id: 19,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/60onz5rq_588A2769.JPG",
    category: "Rooms"
  },
  {
    id: 20,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/e2zewt9r_588A2772.JPG",
    category: "Rooms"
  },
  
  // Rooms - Triple Room (5 images)
  {
    id: 21,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/sgx57p5f_588A2729.JPG",
    category: "Rooms"
  },
  {
    id: 22,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/hra7twcm_588A2736.JPG",
    category: "Rooms"
  },
  {
    id: 23,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/pxiispx6_588A2738.JPG",
    category: "Rooms"
  },
  {
    id: 24,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/14idilvf_588A2739.JPG",
    category: "Rooms"
  },
  {
    id: 25,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/urkjw1mc_588A2741.JPG",
    category: "Rooms"
  },
  
  // Apartments - One Bedroom (5 images)
  {
    id: 26,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/paiyvutm_588A2785.JPG",
    category: "Apartment"
  },
  {
    id: 27,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/vzkljzzg_588A2789.JPG",
    category: "Apartment"
  },
  {
    id: 28,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/51x17fz1_588A2801.JPG",
    category: "Apartment"
  },
  {
    id: 29,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/spvpy3f5_588A2806.JPG",
    category: "Apartment"
  },
  {
    id: 30,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/0utz9btd_588A2781.JPG",
    category: "Apartment"
  },
  
  // Apartments - Royal (5 images)
  {
    id: 31,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/019tewky_588A2519.JPG",
    category: "Apartment"
  },
  {
    id: 32,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/kezje2oz_588A2542.JPG",
    category: "Apartment"
  },
  {
    id: 33,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/g5og817k_588A2550.JPG",
    category: "Apartment"
  },
  {
    id: 34,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/jfhmw31x_588A2555.JPG",
    category: "Apartment"
  },
  {
    id: 35,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/r1595qby_588A2559.JPG",
    category: "Apartment"
  },
  
  // Bathroom images (5 images - reusing bathroom shots from different rooms)
  {
    id: 36,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/cwisygyo_588A2667.JPG",
    category: "Bathroom"
  },
  
  // Additional Pool/Terrace views
  {
    id: 37,
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=1280&q=80",
    category: "Terrace"
  },
  {
    id: 38,
    image: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=1280&q=80",
    category: "Terrace"
  },
  
  // Additional room views for variety
  {
    id: 39,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/2zdwwdoe_588A2656.JPG",
    category: "Rooms"
  },
  {
    id: 40,
    image: "https://customer-assets.emergentagent.com/job_cf14decb-7e72-4ae9-98ca-c0ee15b9566b/artifacts/400tuppx_588A2705.JPG",
    category: "Rooms"
  }
];

// Real reviews inspired by guest reviews feedback
export const testimonials = [
  {
    id: 1,
    name: "Rebecca",
    location: "United Kingdom",
    rating: 5,
    text: "Everything. From the staff to the facility and environment. The location was perfectly placed near Long Beach just a couple minutes away, the staff was amazing.",
    date: "January 2025"
  },
  {
    id: 2,
    name: "Ida",
    location: "Albania",
    rating: 5,
    text: "The food was really good; half board system applied. There were always a variety of tasty options available. The facilities were new. The location was convenient. Parking was always available.",
    date: "December 2024"
  },
  {
    id: 3,
    name: "Sadikaj",
    location: "Kosovo",
    rating: 5,
    text: "The location was perfectly placed near Long Beach just a couple minutes away, the staff was amazing. Food was abundant and very delicious. I had enough parking spaces and the rooms are very comfortable.",
    date: "November 2024"
  },
  {
    id: 4,
    name: "Fahri",
    location: "United Kingdom",
    rating: 5,
    text: "Everything, there is no reason for not to like the property, staff, location, food. All the things was great, the staff was excellent, new hotel!",
    date: "October 2024"
  }
];

export const attractions = [
  {
    id: 1,
    name: "Velika Plaza (Long Beach)",
    distance: "1.8 km",
    description: "13km of sandy beach - one of the longest on the Adriatic Sea. Top-rated beach nearby (8.9 rating)"
  },
  {
    id: 2,
    name: "Ulcinj Old Town",
    distance: "2.5 km",
    description: "Historic fortress with stunning views and charming cobblestone streets"
  },
  {
    id: 3,
    name: "Mala Plaza (Small Beach)",
    distance: "3.2 km",
    description: "Popular city beach with crystal clear waters and beach bars"
  },
  {
    id: 4,
    name: "Ada Bojana",
    distance: "12 km",
    description: "River island paradise famous for kitesurfing and pristine nature"
  }
];
